import {
  getBalance as publicGetBalance,
  listBalances as publicListBalances,
  queryBalances as publicQueryBalances,
  typedQueryBalances as publicTypedQueryBalances,
  changeBalance as publicChangeBalance,
  revertBalanceChange as publicRevertBalanceChange,
} from './benefit-programs-v1-balance-balances.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  BalanceQuery,
  BalancesQueryBuilder,
  typedQueryBalances as universalTypedQueryBalances,
} from './benefit-programs-v1-balance-balances.universal.js';

function customQueryBalances(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryBalances(httpClient)(),
    typedQueryFunction: (query: BalanceQuery) =>
      publicTypedQueryBalances(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): BalancesQueryBuilder;
  function overloadedQuery(
    query: BalanceQuery
  ): ReturnType<typeof universalTypedQueryBalances>;
  function overloadedQuery(query?: BalanceQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getBalance: MaybeContext<
  BuildRESTFunction<typeof publicGetBalance> & typeof publicGetBalance
> = /*#__PURE__*/ createRESTModule(publicGetBalance);
export const listBalances: MaybeContext<
  BuildRESTFunction<typeof publicListBalances> & typeof publicListBalances
> = /*#__PURE__*/ createRESTModule(publicListBalances);
export const changeBalance: MaybeContext<
  BuildRESTFunction<typeof publicChangeBalance> & typeof publicChangeBalance
> = /*#__PURE__*/ createRESTModule(publicChangeBalance);
export const revertBalanceChange: MaybeContext<
  BuildRESTFunction<typeof publicRevertBalanceChange> &
    typeof publicRevertBalanceChange
> = /*#__PURE__*/ createRESTModule(publicRevertBalanceChange);
export const queryBalances: MaybeContext<
  BuildRESTFunction<typeof customQueryBalances> & typeof customQueryBalances
> = /*#__PURE__*/ createRESTModule(customQueryBalances);

export {
  IdentityType,
  PoolStatus,
  SortOrder,
  ChangeBalanceRequestType,
  LimitRule,
  BalanceType,
  Type,
  TransactionReversibility,
  WebhookIdentityType,
} from './benefit-programs-v1-balance-balances.universal.js';
export {
  Balance,
  CommonIdentificationData,
  CommonIdentificationDataIdOneOf,
  BalanceAmount,
  PoolInfo,
  RolloverConfigurationInfo,
  ExtendedFields,
  GetBalanceRequest,
  GetBalanceResponse,
  ListBalancesRequest,
  CursorPaging,
  ListBalancesResponse,
  CursorPagingMetadata,
  Cursors,
  QueryBalancesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  QueryBalancesResponse,
  BalanceChangeBalanceRequest,
  BalanceChangeBalanceRequestOperationOneOf,
  AdjustOptions,
  SetOptions,
  SetInitialOptions,
  TransactionDetails,
  Item,
  ChangeBalanceResponse,
  BalanceExceededLimits,
  BulkChangeBalancesRequest,
  ChangeBalanceRequest,
  ChangeBalanceRequestOperationOneOf,
  BulkChangeBalancesResponse,
  ItemMetadata,
  ApplicationError,
  BulkChangeBalanceResult,
  BulkActionMetadata,
  RevertBalanceChangeRequest,
  RevertBalanceChangeResponse,
  ChangeAlreadyReverted,
  NotEnoughBalance,
  GetTransactionReversibilityRequest,
  GetTransactionReversibilityResponse,
  HealBalanceRequest,
  HealBalanceResponse,
  HealBalanceTenantRequest,
  HealBalanceTenantResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ListBalancesOptions,
  BalancesQueryResult,
  BalancesQueryBuilder,
  BalanceQuerySpec,
  ChangeBalanceOptions,
  ChangeBalanceOptionsOperationOneOf,
  RevertBalanceChangeOptions,
} from './benefit-programs-v1-balance-balances.universal.js';
export { utils } from './benefit-programs-v1-balance-balances.universal.js';
export {
  IdentityTypeWithLiterals,
  PoolStatusWithLiterals,
  SortOrderWithLiterals,
  ChangeBalanceRequestTypeWithLiterals,
  LimitRuleWithLiterals,
  BalanceTypeWithLiterals,
  TypeWithLiterals,
  TransactionReversibilityWithLiterals,
  WebhookIdentityTypeWithLiterals,
  ChangeBalanceApplicationErrors,
  RevertBalanceChangeApplicationErrors,
  CommonQueryWithEntityContext,
  BalanceQuery,
} from './benefit-programs-v1-balance-balances.universal.js';
